import { render } from "./WellFormattedTitle.vue?vue&type=template&id=009b66ea"
import script from "./WellFormattedTitle.vue?vue&type=script&lang=js"
export * from "./WellFormattedTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__